import { useSelector, useDispatch } from "react-redux";
import { selectAppMenuCollapsed } from "../appMenuSelectors";
import { setCollapsed, toggleCollapsed } from "../appMenuSlice";

export const useAppMenu = () => {
	const dispatch = useDispatch();
	const isCollapsed = useSelector(selectAppMenuCollapsed);

	const collapse = (value: boolean) => {
		dispatch(setCollapsed(value));
	};

	const toggle = () => {
		dispatch(toggleCollapsed());
	};

	return { isCollapsed, collapse, toggle };
};
